<div class="physical-reception container-fluid">
  <div class="d-flex" [formGroup]="headerForm">
    <h3><Strong>CONTROLE EXPEDIÇÃO MALHA</Strong></h3>
    <mat-slide-toggle [disableControl]="filterForm.invalid || isLoading || newTime !== undefined" (change)="abrirModal()" labelPosition="before" formControlName="autoRefresh" class="ml-auto">Ativar Auto Refresh</mat-slide-toggle>
    <span style="margin-top: 0.2%" [hidden]="!newTime" class="ml-2">{{newTime + ' segundo(s)'}} </span>
    <button [hidden]="!newTime" mat-icon-button (click)="desativaRefresh()">
      <mat-icon matTooltip="Parar" style="margin-top: -1rem" color="warn">alarm_off</mat-icon>
    </button>
  </div>
  <mat-card>
    <mat-card-header [hidden]="newTime" class="header-padrao">
      <mat-card-title>
        <form class="
              d-flex
              flex-wrap
              align-items-center
              justify-content-start
              filtros-header
            " [formGroup]="filterForm">

          <mat-form-field [hidden]='usuarioEAgente'>
            <mat-label> Regional:</mat-label>
            <mat-select formControlName="regional" disableOptionCentering="true" placeholder="Regional"
              [required]='!usuarioEAgente' (selectionChange)="ListarIatas(); listarRotas()">
              <mat-option><ngx-mat-select-search [formControl]="regionalMultiFilter" placeholderLabel="Buscar..."
              noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
              <mat-option *ngFor="let r of filteredRegional | async" [value]="r?.id">
                {{ r?.nome }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [hidden]='usuarioEAgente'>
            <mat-label>IATA:</mat-label>
            <mat-select formControlName="iataSelecionada" (selectionChange)="listarRotas()" [disableControl]="!regional"
              disableOptionCentering="true" placeholder="Iatas">
              <mat-option><ngx-mat-select-search [formControl]="agenteMultiFilter" placeholderLabel="Buscar..." noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
              <mat-option [value]="0">Todas</mat-option>
              <mat-option *ngFor="let agente of filteredAgentes | async" [value]="agente?.agenteID"
                [matTooltip]="agente.codIATA + '-' + agente.fantasia">
                {{ agente?.codIATA }} - {{ agente?.fantasia }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label> Cliente:</mat-label>
            <mat-select formControlName="clienteSelecionado" disableOptionCentering="true" placeholder="Cliente">
                      <mat-option><ngx-mat-select-search [formControl]="clienteMultiFilter" placeholderLabel="Buscar..."
        noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
              <mat-option [value]="0">Todos</mat-option>
              <mat-option *ngFor="let cliente of filteredClientes | async" [value]="cliente?.id">
                {{ cliente?.nome }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label> Vencimento:</mat-label>
            <mat-select formControlName="vencimentoFormControl" disableOptionCentering="true" placeholder="Vencimento">
              <mat-option value="">Todos</mat-option>
              <mat-option *ngFor="let r of comboVencidos " [value]="r?.id">
                {{ r?.descricao }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [hidden]="vencimentoSelecionado && vencimentoSelecionado !== 3">
            <mat-label> Vencendo nos próximos:</mat-label>
            <mat-select formControlName="pedidosvencendoProximos" disableOptionCentering="true"
              placeholder="Vencendo nos próximos">
              <mat-option value="" selected>Nenhum</mat-option>
              <mat-option *ngFor="let r of comboDiasFuturos " [value]="r?.id">
                {{ r?.descricao }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label> Situação:</mat-label>
            <mat-select formControlName="recepcaoBaseFormControl" disableOptionCentering="true"
              placeholder="Recepção em base">
              <mat-option *ngFor="let r of comboRecepcaoBase " [value]="r?.id">
                {{ r?.descricao }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Segmento:</mat-label>
            <mat-select formControlName="negocioFormControl">
              <mat-option value="">Todos</mat-option>
              <mat-option *ngFor="let n of negocios" [value]="n.classe">
                {{ n.descricao }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="div-rotas">
            Quebra por Rota:
            <mat-slide-toggle formControlName="flgRota"></mat-slide-toggle>
            <mat-form-field style="margin-left: 20px; max-width: 250px" [disableControl]="!regional" [hidden]="!flgRota">
              <mat-label>Rotas:</mat-label>
              <mat-select [(ngModel)]="rotaId" formControlName="rotaSelecionada" disableOptionCentering="true"
                placeholder="Rotas" [disableControl]="!regional">
                <mat-option><ngx-mat-select-search [formControl]="RotasMultiFilter" placeholderLabel="Buscar..."
                noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
                <mat-option value="">Todas</mat-option>
                <mat-option *ngFor="let rota of filteredRotas | async" [value]="rota?.rotaId">
                  {{ rota?.description }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <button mat-icon-button type="button" matTooltip="Limpar Campos" (click)="clearFields()">
            <i class="fas fa-eraser eraser-button"></i>
          </button>
          <button mat-icon-button matTooltip="Pesquisar" (click)="pesquisarMalha()" [disabled]="filterForm.invalid || isLoading">
            <i class="fas fa-search search-button cursor-pointer-icon"></i>
          </button>
        </form>
      </mat-card-title>
    </mat-card-header>
    <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
    <mat-card-content class="no-padding" [hidden]="!exibirGrid">
      <div [hidden]="isLoading || gridMalha?.data?.length === 0 || gridMalha==null">
        <div>
          <table id="relatorios" mat-table [dataSource]="gridMalha" class="table-sm" multiTemplateDataRows>
            <ng-container matColumnDef="iata">
              <th mat-header-cell class="pl-3" *matHeaderCellDef [attr.rowspan]="2">IATA/ROTAS</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                {{ gridMalha.iata }} <small *ngIf="gridMalha.rotas?.length > 0">
                  ({{gridMalha.rotas?.length}}rotas)</small>
              </td>
            </ng-container>
            <ng-container matColumnDef="pedidoS_VENCIDOS_RECEPCAO_BASE">
              <th mat-header-cell *matHeaderCellDef style="width:120px">Na base</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.pedidoS_VENCIDOS_RECEPCAO_BASE || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, 2, 1)">
                  {{ gridMalha.pedidoS_VENCIDOS_RECEPCAO_BASE }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="pedidoS_VENCIDOS_EM_ROTA">
              <th mat-header-cell *matHeaderCellDef style="width:120px">Em rota</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.pedidoS_VENCIDOS_EM_ROTA || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, 2, 2)">
                  {{ gridMalha.pedidoS_VENCIDOS_EM_ROTA }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="pedidoS_VENCIDOS_PREFAE">
              <th mat-header-cell *matHeaderCellDef style="width:120px">Em Pré-Fae</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.pedidoS_VENCIDOS_PREFAE || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, 2, 4)">
                  {{ gridMalha.pedidoS_VENCIDOS_PREFAE }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="pedidoS_VENCIDOS_CAMINHO">
              <th mat-header-cell *matHeaderCellDef style="width:120px">A Caminho</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.pedidoS_VENCIDOS_CAMINHO || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, 2, 3)">
                  {{ gridMalha.pedidoS_VENCIDOS_CAMINHO }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="pedidoS_VENCE_HOJE_RECEPCAO_BASE">
              <th mat-header-cell *matHeaderCellDef style="width:120px">Na Base</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.pedidoS_VENCE_HOJE_RECEPCAO_BASE || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, 1,1)">
                  {{ gridMalha.pedidoS_VENCE_HOJE_RECEPCAO_BASE }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="pedidoS_VENCE_HOJE_ROTA">
              <th mat-header-cell *matHeaderCellDef style="width:120px">Em rota</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.pedidoS_VENCE_HOJE_ROTA || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, 1,2)">
                  {{ gridMalha.pedidoS_VENCE_HOJE_ROTA }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="pedidoS_VENCE_HOJE_PREFAE">
              <th mat-header-cell *matHeaderCellDef style="width:120px">Em Pré-Fae</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.pedidoS_VENCE_HOJE_PREFAE || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, 1,4)">
                  {{ gridMalha.pedidoS_VENCE_HOJE_PREFAE }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="pedidoS_VENCE_HOJE_CAMINHO">
              <th mat-header-cell *matHeaderCellDef style="width:120px">A Caminho</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.pedidoS_VENCE_HOJE_CAMINHO || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, 1,3)">
                  {{ gridMalha.pedidoS_VENCE_HOJE_CAMINHO }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="pedidoS_VENCENDO_RECEPCAO_BASE">
              <th mat-header-cell *matHeaderCellDef style="width:120px">
                Na base</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.pedidoS_VENCENDO_RECEPCAO_BASE || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, 3, 1)">
                  {{ gridMalha.pedidoS_VENCENDO_RECEPCAO_BASE }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="pedidoS_VENCENDO_ROTA">
              <th mat-header-cell *matHeaderCellDef style="width:120px">Em rota
              </th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.pedidoS_VENCENDO_ROTA || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, 3, 2)">
                  {{ gridMalha.pedidoS_VENCENDO_ROTA }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="pedidoS_VENCENDO_PREFAE">
              <th mat-header-cell *matHeaderCellDef style="width:120px">
                Em Pré-Fae
              </th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.pedidoS_VENCENDO_PREFAE || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, 3, 4)">
                  {{ gridMalha.pedidoS_VENCENDO_PREFAE }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="pedidoS_VENCENDO_CAMINHO">
              <th mat-header-cell *matHeaderCellDef style="width:120px">
                A Caminho
              </th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.pedidoS_VENCENDO_CAMINHO || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, 3, 3)">
                  {{ gridMalha.pedidoS_VENCENDO_CAMINHO }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="totaL_BASE">
              <th mat-header-cell *matHeaderCellDef style="width:120px">Na Base</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.totaL_BASE || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, objConsultaInicial.tipo_Vencimento, 1)">
                  {{ gridMalha.totaL_BASE }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="totaL_ROTA">
              <th mat-header-cell *matHeaderCellDef style="width:120px">Em rota</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.totaL_ROTA || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, objConsultaInicial.tipo_Vencimento, 2)">
                  {{ gridMalha.totaL_ROTA }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="totaL_PREFAE">
              <th mat-header-cell *matHeaderCellDef style="width:120px">Em Pré-Fae</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.totaL_PREFAE || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, objConsultaInicial.tipo_Vencimento, 4)">
                  {{ gridMalha.totaL_PREFAE }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="totaL_CAMINHO">
              <th mat-header-cell *matHeaderCellDef style="width:120px">A Caminho</th>
              <td mat-cell *matCellDef="let gridMalha" [class]="gridMalha.rotas?.length > 0?'temSubgrid':''">
                <button mat-icon-button type="button" matTooltip="Clique para efetuar o Download"
                  [disabled]="!gridMalha.totaL_CAMINHO || isLoadingDownload"
                  (click)="baixarExcelIata(gridMalha, objConsultaInicial.tipo_Vencimento, 3)">
                  {{ gridMalha.totaL_CAMINHO }}
                </button>
              </td>
            </ng-container>
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let gridMalha" [attr.colspan]="displayedColumnsRota().length">
                <div class="example-element-detail"
                  [@detailExpand]="((gridMalha == expandedElement)&&(gridMalha.rotas?.length>0) ||  expandir == true )? 'expanded' : 'collapsed'">
                  <table mat-table [dataSource]="gridMalha.rotas" class="table-inside">
                    <ng-container matColumnDef="{{innerColumn}}" *ngFor="let innerColumn of displayedColumnsRota()">
                      <th mat-header-cell *matHeaderCellDef style="width:120px;"></th>
                      <td mat-cell *matCellDef="let element">
                        <span *ngIf="innerColumn=='rota'">{{ element[innerColumn] }}</span>
                        <button *ngIf="innerColumn!='rota'" mat-icon-button type="button"
                          matTooltip="Clique para efetuar o Download"
                          [disabled]="!element[innerColumn] || isLoadingDownload"
                          (click)="baixarExcelRota(element, innerColumn)">
                          {{ element[innerColumn] }}
                        </button>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsRota()" style="height:0"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsRota();"></tr>
                  </table>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="header-row-1">
              <th mat-header-cell *matHeaderCellDef class="header1">
                <div [hidden]="!objConsultaInicial?.flgRota">
                  <span class="badge badge-light botaoExpand" (click)="expandirRota(true)">+ Expandir</span>
                  <span class="badge badge-light botaoExpand" (click)="expandirRota(false)">- Recolher</span>
                </div>
              </th>
            </ng-container>
            <!-- header-row-pedidos-vencidos -->
            <ng-container matColumnDef="header-row-pedidos-vencidos">
              <th mat-header-cell *matHeaderCellDef [attr.colspan]="headerColspan(2)" class="header2"> Vencidos </th>
            </ng-container>
            <!--header-row-pedidos-vencendo-hoje -->
            <ng-container matColumnDef="header-row-pedidos-vencendo-hoje">
              <th mat-header-cell *matHeaderCellDef [attr.colspan]="headerColspan(1)" class="header2"> Vencendo Hoje
              </th>
            </ng-container>
            <!--header-row-pedidos-vencendo-proximos -->
            <ng-container matColumnDef="header-row-pedidos-vencendo-proximos">
              <th mat-header-cell [hidden]="objConsultaInicial?.pedidosVencendo == 0" *matHeaderCellDef
                [attr.colspan]="headerColspan(3)" class="header2"> Vencendo nos próximos
                {{objConsultaInicial?.pedidosVencendo}} dias </th>
            </ng-container>
            <!--header-row-total -->
            <ng-container matColumnDef="header-row-total">
              <th mat-header-cell *matHeaderCellDef [attr.colspan]="headerColspan()" class="header2"> Total </th>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="headerColumns()"> </tr>
            <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns()" class="example-element-row"
              [class.example-expanded-row]="expandedElement === row"
              (click)="expandedElement = expandedElement === row ? null : row"></tr>

            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
          </table>
        </div>
        <div class="text-right p-1 mt-1">
          <button mat-flat-button type="button" color="success" (click)="downloadExcel(this.objConsultaInicial.tipo_Vencimento, this.objConsultaInicial.tipo_Recebimento,
            this.objConsultaInicial.agenteId, objConsultaInicial.rotaId)" [disabled]="isLoadingDownload">
            <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
              <mat-spinner diameter="20" color="dark"></mat-spinner>
              &nbsp; Baixando
            </span>
            <span *ngIf="!isLoadingDownload">
              <i class="fas fa-file-excel"></i> Baixar Todos
            </span>
          </button>
        </div>
      </div>
      <div *ngIf="!isLoading && gridMalha?.data?.length === 0" class="d-flex justify-content-center align-items-center"
        style="height: 100px">
        Não retornou registros.
      </div>
    </mat-card-content>
  </mat-card>
</div>
